import React from 'react'
import { Space, Table } from 'antd'
import { isEmpty } from 'lodash'
import { defaultPagination } from '../../../../services/api/client/types'
import { displayDatetime } from '../../../../utils/formatter'
import { FeatureEnabled } from '../../../../components'
import { InvoiceListItem } from '../../../../lib/types/Invoice'
import { GenerateQR } from './GenerateQr'
import { DownloadDocument } from './DownloadDocument'
import { PayInvoice } from './PayInvoice'

type TableProps = {
  invoices?: InvoiceListItem[]

  meta?: any
  isLoading: boolean
  onPaginationChange: (page: number, perPage?: number) => void
  onInvoiceUpdate: (updatedInvoice: InvoiceListItem) => void
}

export const InvoicesTable: React.FunctionComponent<TableProps> = ({
  invoices,
  meta,
  isLoading,
  onPaginationChange,
  onInvoiceUpdate,
}) => {
  return (
    <Table
      dataSource={invoices}
      columns={[
        {
          title: 'ID',
          dataIndex: 'id',
        },
        {
          dataIndex: 'name',
        },
        {
          title: 'Оплачено',
          render: (_, invoice) => {
            const invoicePaid = !isEmpty(invoice.paidAt)
            return (
              <Space>
                <FeatureEnabled value={invoicePaid} />
                {invoicePaid && displayDatetime(invoice.paidAt)}
              </Space>
            )
          },
        },
        {
          title: 'Дата',
          render: (_, invoice) => displayDatetime(invoice.createdAt),
        },
        {
          title: 'Управление',
          render: (_, invoice) => {
            const invoicePaid = !isEmpty(invoice.paidAt)
            return (
              <Space>
                <GenerateQR invoice={invoice} />
                <DownloadDocument invoice={invoice} />
                <PayInvoice
                  invoicePaid={invoicePaid}
                  invoice={invoice}
                  onInvoiceUpdate={onInvoiceUpdate}
                />
              </Space>
            )
          },
        },
      ]}
      pagination={{
        onChange: onPaginationChange,
        hideOnSinglePage: true,
        current: meta?.page || defaultPagination.page,
        pageSize: meta?.perPage || defaultPagination.perPage,
        total: meta?.totalCount,
        defaultCurrent: defaultPagination.page,
        defaultPageSize: defaultPagination.perPage,
      }}
      loading={isLoading}
      rowKey={(invoice) => invoice.id}
    />
  )
}
